/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Start_DateInputs */

const en_admin_external_booking_edit_start_date = /** @type {(inputs: Admin_External_Booking_Edit_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start date`)
};

const de_admin_external_booking_edit_start_date = /** @type {(inputs: Admin_External_Booking_Edit_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdatum`)
};

const es_admin_external_booking_edit_start_date = /** @type {(inputs: Admin_External_Booking_Edit_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de inicio`)
};

const fr_admin_external_booking_edit_start_date = /** @type {(inputs: Admin_External_Booking_Edit_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de début`)
};

const nl_admin_external_booking_edit_start_date = /** @type {(inputs: Admin_External_Booking_Edit_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdatum`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Start_DateInputs) => LocalizedString} */
const it_admin_external_booking_edit_start_date = en_admin_external_booking_edit_start_date;

/** @type {(inputs: Admin_External_Booking_Edit_Start_DateInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_start_date = en_admin_external_booking_edit_start_date;

/** @type {(inputs: Admin_External_Booking_Edit_Start_DateInputs) => LocalizedString} */
const pl_admin_external_booking_edit_start_date = en_admin_external_booking_edit_start_date;

/** @type {(inputs: Admin_External_Booking_Edit_Start_DateInputs) => LocalizedString} */
const hu_admin_external_booking_edit_start_date = en_admin_external_booking_edit_start_date;

/** @type {(inputs: Admin_External_Booking_Edit_Start_DateInputs) => LocalizedString} */
const ro_admin_external_booking_edit_start_date = en_admin_external_booking_edit_start_date;

/**
* | output |
* | --- |
* | "Start date" |
*
* @param {Admin_External_Booking_Edit_Start_DateInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_start_date = /** @type {((inputs?: Admin_External_Booking_Edit_Start_DateInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Start_DateInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_start_date(inputs)
	if (locale === "de") return de_admin_external_booking_edit_start_date(inputs)
	if (locale === "es") return es_admin_external_booking_edit_start_date(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_start_date(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_start_date(inputs)
	if (locale === "it") return it_admin_external_booking_edit_start_date(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_start_date(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_start_date(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_start_date(inputs)
	return ro_admin_external_booking_edit_start_date(inputs)
});
export { admin_external_booking_edit_start_date as "admin.external_booking_edit.start_date" }